import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN, UserIdService } from '@spartacus/core';
import { combineLatest, Observable, Subject, filter, map, switchMap, take } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Injectable } from '@angular/core';

import { RelayPoint, RelayPointList } from '../models';
import { StoreTypeEnum } from '../enums';

import '../models/augmented-spartacus-cart.model';

@Injectable({
  providedIn: 'root'
})
export class RelayPointService {
  formIsValid: Subject<boolean> = new Subject<boolean>();

  constructor(
    private occEndpointService: OccEndpointsService,
    private httpClient: HttpClient,
    private userIdService: UserIdService,
    private cartIdService: ActiveCartService
  ) {}

  getRelayPoints(relayParams: Record<string, any>): Observable<RelayPoint[]> {
    return combineLatest([
      this.userIdService.takeUserId(false),
      this.cartIdService.getActiveCartId(),
      this.cartIdService.getActive()
    ]).pipe(
      filter(([userId, cartId]) => !!userId && !!cartId),
      take(1),
      switchMap(([userId, cartId, cart]) => {
        let headers = new HttpHeaders();
        if (userId === OCC_USER_ID_ANONYMOUS) {
          headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
        }
        if (cart.isForfait && cart.serviceShippingIncluded) {
          delete relayParams['streetName'];
          relayParams = {
            ...relayParams,
            deliveryProvider: StoreTypeEnum.COLISSIMO
          };
        }
        const url = this.occEndpointService.buildUrl('relayPoint', {
          urlParams: { userId, cartId },
          queryParams: relayParams
        });
        return this.httpClient.get<RelayPointList>(url, { headers });
      }),
      map(({ relayPoints }) => relayPoints)
    );
  }

  selectRelayPoint(relayPoint: RelayPoint): Observable<RelayPoint> {
    return combineLatest([this.userIdService.takeUserId(false), this.cartIdService.getActiveCartId()]).pipe(
      filter(([userId, cartId]) => !!userId && !!cartId),
      take(1),
      switchMap(([userId, cartId]) => {
        const url = this.occEndpointService.buildUrl('relay', {
          urlParams: { userId, cartId },
          queryParams: {
            relayId: relayPoint.id,
            longitude: relayPoint.geoPoint?.longitude,
            latitude: relayPoint.geoPoint?.latitude,
            country: relayPoint?.country
          }
        });
        return this.httpClient.put<RelayPoint>(url, {});
      })
    );
  }

  selectNShiftRelayPoint(relayPoint: RelayPoint): Observable<RelayPoint> {
    return combineLatest([this.userIdService.takeUserId(false), this.cartIdService.getActiveCartId()]).pipe(
      filter(([userId, cartId]) => !!userId && !!cartId),
      take(1),
      switchMap(([userId, cartId]) => {
        const url = this.occEndpointService.buildUrl('nShiftRelay', {
          urlParams: { userId, cartId },
          queryParams: {
            country: relayPoint?.country
          }
        });
        return this.httpClient.put<RelayPoint>(url, relayPoint);
      })
    );
  }

  setRelayPointDeliveryInformation(userData: any): Observable<any> {
    return combineLatest([this.userIdService.takeUserId(false), this.cartIdService.getActiveCartId()]).pipe(
      filter(([userId, cartId]) => !!userId && !!cartId),
      take(1),
      switchMap(([userId, cartId]) => {
        const url = this.occEndpointService.buildUrl('relayPointDeliveryInformation', {
          urlParams: { userId, cartId },
          queryParams: {
            firstName: userData?.firstName,
            lastName: userData?.lastName,
            email: userData?.email,
            phone: userData?.phone
          }
        });
        return this.httpClient.post<any>(url, {});
      })
    );
  }
}
